import {IDispatch, IStore} from '../store';
import {yourMixSelector} from './yourMix.selector';
import {YOUR_MIX_STORAGE_KEY} from './yourMix.constants';

export const persistYourMix: () => (dispatch: IDispatch, getState: () => IStore) => void =
  () => (dispatch: IDispatch, getState: () => IStore) => {

    localStorage.setItem(YOUR_MIX_STORAGE_KEY, JSON.stringify(yourMixSelector(getState())));
  };
